// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__hkfCu","containerItemsCenter":"Skeleton_containerItemsCenter__haibm"};